import { JRCAvatar } from '../JRCAvatar/JRCAvatar';
import { JRCPagination } from '../JRCPagination/JRCPagination';
import React from 'react';
import { CSSAvatarWrapper } from '../JRCModalUserList/JRCModalUserList';
import styled from 'styled-components';
import { JRCInputSearchRaw } from '../Form/Input/JRCInputSearchRaw/JRCInputSearchRaw';
import { JRCLoader } from '../JRCLoader/JRCLoader';
import { useIntl } from 'react-intl';
import { jObjectLittle } from 'jamespot-user-api';

export type JRCObjectListProps<T extends jObjectLittle = jObjectLittle> = {
    list?: {
        data: T[];
        cnt?: number;
        limit?: number;
        page?: number;
    };
    onPageChange: (page: number) => void;
    actionComponent?: (obj: T) => React.ReactNode;
    onClick?: (obj: T) => void;
    onSearch?: (query: string) => void;
    isLoading?: boolean;
};

const CSSObjectList = styled.div`
    display: flex;
    flex-direction: column;
    padding: 0px ${({ theme }) => theme.space.md};
    gap: 8px;
`;

const CSSSpaceBetween = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;

    &:hover {
        background-color: ${(props) => props.theme.color.grey0};
    }
`;

const CSSObjectItem = styled.a`
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 8px;
    cursor: pointer;
`;

const ActionComponent = styled.div`
    margin-right: ${({ theme }) => theme.space.sm}px;
`;

const LoaderWrapper = styled.div`
    margin-top: ${({ theme }) => theme.space.l}px;
`;

const EmptyWrapper = styled.div`
    align-items: center;
    display: flex;
    flex: 1;
    justify-content: center;
    min-height: 100px;
`;

export const JRCObjectList = <T extends jObjectLittle = jObjectLittle>({
    list,
    onPageChange,
    onClick,
    actionComponent,
    onSearch,
    isLoading,
}: JRCObjectListProps<T>) => {
    const intl = useIntl();

    return (
        <CSSObjectList>
            {onSearch && <JRCInputSearchRaw onChange={onSearch} />}
            {isLoading && (
                <LoaderWrapper>
                    <JRCLoader size={'m'} />
                </LoaderWrapper>
            )}
            {list && !isLoading && (
                <>
                    {list.data.map((obj) => (
                        <CSSSpaceBetween key={obj.id}>
                            <CSSObjectItem href={onClick ? undefined : obj._url}>
                                <CSSAvatarWrapper>
                                    <JRCAvatar uri={obj.uri} size={5} variant="circle" alt="" />
                                </CSSAvatarWrapper>
                                <div>{obj.title}</div>
                            </CSSObjectItem>
                            {actionComponent && <ActionComponent>{actionComponent(obj)}</ActionComponent>}
                        </CSSSpaceBetween>
                    ))}
                    {Math.ceil((list?.cnt ?? 0) / (list?.limit ?? 10)) > 1 && (
                        <JRCPagination
                            activePage={list?.page ?? 1}
                            nbrOfPage={Math.ceil((list?.cnt ?? 0) / (list?.limit ?? 10))}
                            clickHandler={onPageChange}
                        />
                    )}
                    {list?.cnt === 0 && <EmptyWrapper>{intl.formatMessage({ id: 'GLOBAL_No_Result' })}</EmptyWrapper>}
                </>
            )}
        </CSSObjectList>
    );
};
